import Http from '@/utils/request'

/**
 * 文件上传响应接口
 */
export interface UploadFileRes {
  /** code:响应码, 0:成功 */
  code: number
  /** msg:响应信息 */
  msg: string
  /** 响应数据 */
  data: {
    /** 上传后的文件 URL 列表 */
    list: string[]
  }
}

/**
 * 上传文件
 * @param file 要上传的文件对象
 * @returns 上传后的文件 URL
 */
export function uploadFile(file: File): Promise<string> {
  if (!file) {
    console.error('[upload] 上传失败：缺少文件')
    return Promise.reject(new Error('缺少文件'))
  }

  const formData = new FormData()
  formData.append('mFile', file)
  formData.append('moderate', 'false')
  formData.append('keyPath', 'image/')

  return Http({
    url: '/attach/upload',
    method: 'post',
    data: formData,
    headers: {
      // 移除默认的 Content-Type，让浏览器自动设置 multipart/form-data 和 boundary
      'Content-Type': undefined,
    },
  }).then((res) => {
    const uploadRes = res as unknown as UploadFileRes
    if (uploadRes.data && Array.isArray(uploadRes.data.list) && uploadRes.data.list[0]) {
      const url = uploadRes.data.list[0]
      console.log('[upload] 上传成功:', url)
      return url
    } else {
      console.error('[upload] 上传失败：返回数据格式错误', uploadRes)
      throw new Error('返回数据格式错误')
    }
  })
}

/**
 * 通用响应结果接口
 */
export interface RetResult<T = unknown> {
  /** code:响应码, 302:登录认证失败，303：无权限访问接口，413：AES加密接口参数过期，600：用户资源不足 */
  code: number
  /** msg:响应信息 */
  msg: string
  /** errStyle:错误提示样式, toast：默认，dialog：自定义弹窗 */
  errStyle?: string | null
  /** errTitle:错误弹窗标题 */
  errTitle?: string | null
  /** data:响应数据 */
  data?: T
}

/**
 * 字典数据接口（通用格式，支持不同的字段）
 */
export interface DictData {
  /** 字典项的值，通常是字符串数组 */
  [key: string]: string[] | unknown
}

/**
 * MEDIA_WHITE 字典数据类型
 */
export interface MediaWhiteDictData extends DictData {
  /** 用户ID列表 */
  uid: string[]
}

/**
 * 根据 code 获取字典对象
 * @param code 字典代码，默认为 'MEDIA_WHITE'
 * @returns 字典数据
 */
export function byCode<T extends DictData = MediaWhiteDictData>(
  code: string = 'MEDIA_WHITE',
): Promise<RetResult<T>> {
  return Http({
    url: `/dict/obj/${code}`,
    method: 'get',
  }).then((res) => {
    return res as unknown as RetResult<T>
  })
}

/**
 * 通过用户id获取身份，多个用,隔开
 * @returns 响应数据
 */
export function getByUserId(): Promise<RetResult<string>> {
  return Http({
    url: '/white/user/get-by-user-id',
    method: 'get',
  }).then((res) => {
    return res as unknown as RetResult<string>
  })
}
